module.exports = __webpack_public_path__ + "static/media/modal-edge-shape-1.06cfeb08.png";